// extracted by mini-css-extract-plugin
export default {"wrapper":"layout_wrapper__2p7uZ","headerEditProfile":"layout_headerEditProfile__ThJXu"};